export const lifestyleFactors = [
  { value: "sleep", label: "Sleep", placeholder: "Notes on sleep" },
  { value: "exercise", label: "Exercise", placeholder: "Notes on exercise" },
  { value: "stress", label: "Stress", placeholder: "Notes on stress" },
  { value: "hydration", label: "Hydration", placeholder: "Notes on hydration" },
  { value: "caffeine", label: "Caffeine", placeholder: "Notes on caffeine" },
  { value: "alcohol", label: "Alcohol", placeholder: "Notes on alcohol" },
  {
    value: "medication",
    label: "Medication",
    placeholder: "Notes on medication",
  },
  {
    value: "environment",
    label: "Environment",
    placeholder: "Notes on environment",
  },
  {
    value: "social interactions",
    label: "Social Interactions",
    placeholder: "Notes on social interactions",
  },
  { value: "workload", label: "Workload", placeholder: "Notes on workload" },
  {
    value: "screen time",
    label: "Screen Time",
    placeholder: "Notes on screen time",
  },
  {
    value: "dietary changes",
    label: "Dietary Changes",
    placeholder: "Notes on dietary changes",
  },
];

export const mentalSymptoms = {
  "Mood & Emotional Shifts": [
    "Calmness or inner peace",
    "Anxiety or nervousness",
    "Irritability or crankiness",
    "Restlessness or unease",
    "Sense of joy or happiness",
    "Frustration or impatience",
    "Sadness or melancholy",
    "Increased confidence",
    "Sense of contentment or satisfaction",
    "Agitation or anger",
    "Feelings of guilt or shame",
    "Impulsiveness or lack of control",
    "Sense of relief or release",
    "Empowerment or feeling in control",
    "Mood swings or rapid emotional shifts",
  ],
  "Motivation & Drive": [
    "Sense of motivation or ambition",
    "Procrastination or avoidance",
    "Feeling inspired or creative",
    "Lack of interest or enthusiasm",
    "Sense of drive or determination",
    "Indifference or apathy",
    "Need for distraction or escapism",
  ],
  "Self-Perception & Body Image": [
    "Positive self-image",
    "Negative self-image or self-criticism",
    "Thoughts about body weight or shape",
    "Self-doubt or insecurity",
    "Confidence or self-assurance",
    "Feelings of self-worth or pride",
    "Perception of being “too full” or “empty”",
  ],
  "Mental Clarity & Cognitive Function": [
    "Clear-headedness or focus",
    "Brain fog or mental cloudiness",
    "Quick thinking or mental agility",
    "Difficulty concentrating",
    "Disorganization or scattered thoughts",
    "Sharp memory or recall",
    "Forgetfulness or confusion",
    "Enhanced problem-solving ability",
    "Slowness in processing information",
    "Daydreaming or zoning out",
  ],
  "Stress & Resilience": [
    "High resilience or adaptability",
    "Sensitivity to minor stressors",
    "Ability to cope with challenges",
    "Overwhelm or sense of dread",
    "Sense of mental balance",
    "Compulsiveness or obsession",
    "Sense of “inner strength”",
  ],
  "Energy & Excitement Levels": [
    "Energized or revitalized",
    "Sluggish or “weighted down”",
    "Jitters or edginess",
    "Feeling hyper or overstimulated",
    "Tranquility or relaxation",
    "Boredom or lack of stimulation",
    "Hyperfocus on a task or idea",
    "“Overdrive” or heightened alertness",
    "Sense of fulfillment or completion",
    "Emotional “emptiness” or “void”",
  ],
  "Cravings & Urges": [
    "Strong cravings for certain foods or flavors",
    "Urge for comfort foods",
    "Need for sugary or salty foods",
    "Compulsion to snack or binge",
    "Emotional attachment to food",
    "Disinterest in food or lack of appetite",
    "Desire for “healthy” or “fresh” foods",
  ],
};

export const physicalSymptoms = {
  "Digestive Symptoms": [
    "Bloating",
    "Gas",
    "Stomach cramps or pain",
    "Nausea or queasiness",
    "Acid reflux or heartburn",
    "Burping",
    "Constipation",
    "Diarrhea",
    "Indigestion",
    "Feeling overly full or “stuffed”",
    "Feeling hungry soon after eating",
    "Abdominal distension",
    "Gurgling sounds in the stomach",
    "Feeling of emptiness or “hollowness” in the stomach",
  ],
  "Energy Levels": [
    "Sudden energy boost or surge",
    "Sluggishness or heaviness",
    "Mid-meal energy crash",
    "Post-meal energy dip or fatigue",
    "Feeling energized and alert",
    "Jitters or shakiness",
    "Restlessness or inability to relax",
    "Sleepiness or drowsiness",
  ],
  "Mental and Cognitive Symptoms": [
    "Brain fog",
    "Mental clarity",
    "Increased focus or sharpness",
    "Difficulty concentrating",
    "Irritability or moodiness",
    "Anxiety or nervousness",
    "Sense of calm or relaxation",
    "Dizziness or lightheadedness",
    "Feelings of euphoria or heightened mood",
    "Impulsivity or craving for more food",
    "Increased cravings (e.g., for sugar or carbs)",
    "Difficulty making decisions or organizing thoughts",
  ],
  "Cardiovascular Symptoms": [
    "Heart palpitations or fluttering",
    "Rapid heartbeat",
    "Slow heartbeat",
    "Lightheadedness upon standing",
    "Flushed or warm sensation",
    "Blood pressure changes (some people feel it as warmth or slight tension)",
  ],
  "Muscular Symptoms": [
    "Muscle cramps or spasms",
    "Muscle tension or tightness",
    "Joint stiffness or pain",
    "Muscle weakness",
    "Muscle fatigue or heaviness",
    "Tremors or shaky hands",
  ],
  "Sensory and Neurological Symptoms": [
    "Headache or migraine",
    "Sensitivity to light or sound",
    "Tinnitus (ringing in the ears)",
    "Eye strain or blurry vision",
    "Sensations of tingling or numbness",
    "Sweating or hot flashes",
    "Cold hands or feet",
    "Goosebumps or chills",
    "Changes in taste perception",
    "Dry mouth or unusual thirst",
    "Excess saliva or metallic taste",
  ],
  "Skin and Allergic Reactions": [
    "Flushed or reddened skin",
    "Hives or itching",
    "Skin rashes or irritation",
    "Puffiness or swelling (face, hands, feet)",
    "Breakouts or acne",
    "Dark circles under the eyes",
    "Dry, itchy skin",
    "Watery or itchy eyes",
    "Sinus congestion or runny nose",
    "Scratchy throat",
  ],
  "Respiratory Symptoms": [
    "Shortness of breath",
    "Chest tightness",
    "Increased mucus or phlegm",
    "Wheezing or coughing",
    "Feeling of throat tightness or swelling",
    "Sneezing",
  ],
  "Overall Body Sensations": [
    "Feeling “light” or “airy”",
    "Feeling grounded or balanced",
    "Sense of calm or peacefulness",
    "Irritability or restlessness",
    "Sensation of warmth or coldness",
    "Feeling of pressure or heaviness in certain areas",
    "Sudden hunger or craving (even after eating)",
  ],
};

export const meditationTypes = [
  "Mindfulness Meditation",
  "Guided Meditation",
  "Breathwork",
  "Body Scan",
  "Binaural Beats",
  "Sound Meditation",
  "Yoga Nidra",
  "Walking Meditation",
  "Grounding Meditation",
  "Nature Meditation",
  "Movement Meditation",
  "Hypnotherapy",
  "Gratitude Meditation",
];

export const emotionalSymptoms = [
  "Calm",
  "Anxious",
  "Focused",
  "Distracted",
  "Peaceful",
  "Irritable",
  "Centered",
  "Overwhelmed",
  "Present",
  "Disconnected",
  "Grateful",
  "Sad",
  "Content",
  "Angry",
  "Joyful",
  "Nervous",
  "Frustrated",
  "Hopeful",
  "Lonely",
  "Empowered",
  "Confused",
  "Curious",
  "Secure",
  "Insecure",
  "No noticeable emotional shift",
];
